import styled from 'styled-components';

export const SwitchWrapper = styled.div`
  && .ant-select-selector {
    padding-left: 68px;
  }
`;
